/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';

import styled from 'styled-components';

import { withStyles } from '@material-ui/core/styles';
import { asField } from 'informed';

import Option from './SelectOption';
import HtmlTooltip from './HtmlTooltip';

const StyledFormControl = styled(FormControl)`
  width: 100%;
  font-size: 14px;
`;
const StyledSelect = styled(Select)`
  div > div {
    min-height: 1.1em;
  }
`;

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: '1rem',
    padding: '10px',
  },
}))(Tooltip);

class SelectComponent extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  handleChange = e => {
    const { fieldApi, onChange } = this.props;
    if (fieldApi.setValue) fieldApi.setValue(e.target.value);

    if (onChange) {
      onChange(e.target.value);
    }
  };

  render() {
    const { fieldApi, fieldState, ...props } = this.props;
    const { value } = fieldState;
    const { setTouched } = fieldApi;
    const {
      // onChange,
      onBlur,
      field,
      // initialValue,
      // children,
      multiple,
      /* forwardedRef, //Warning: React does not recognize the `forwardedRef` prop on a DOM element. */

      label = '',
      //   name = "default_name",
      id = String(Math.floor(Math.random() * 1e8)),
      helperText = '',
      options = [],
      disabled = false,
      required,
      tooltip,
      // ...rest
    } = props;

    const LabelTooltiped = tooltip ? (
      <LightTooltip title={tooltip}>
        <InputLabel shrink htmlFor={id}>
          {label} {required ? '*' : ''}
        </InputLabel>
      </LightTooltip>
    ) : (
      <InputLabel shrink htmlFor={id}>
        {label} {required ? '*' : ''}
      </InputLabel>
    );

    return (
      <>
        {tooltip && (
          <HtmlTooltip title={tooltip}>
            <span className="helper">?</span>
          </HtmlTooltip>
        )}
        <StyledFormControl error={!!fieldState.error}>
          {LabelTooltiped}
          <StyledSelect
            // {...rest}
            required={required}
            multiple={multiple}
            name={field}
            ref={this.selectRef}
            // eslint-disable-next-line no-nested-ternary
            value={value || value === 0 ? value : multiple ? [] : ''}
            onChange={this.handleChange}
            onBlur={e => {
              setTouched();
              if (onBlur) {
                onBlur(e);
              }
            }}
            // material-ui props
            inputProps={{
              //   name,
              id,
            }}
            disabled={disabled}
          >
            {options.map(option => (
              <Option
                key={option.value}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...option}
              >
                {' '}
                {option.text}
              </Option>
            ))}
          </StyledSelect>
          <FormHelperText>{fieldState.error || helperText}</FormHelperText>
        </StyledFormControl>
      </>
    );
  }
}

SelectComponent.propTypes = {
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ),
};

SelectComponent.defaultProps = {
  required: false,
  disabled: false,
  options: [],
};

export default asField(SelectComponent);
